module.exports = __webpack_public_path__ + "static/001-b2d3fb034f6ba647b1d46376022b0116.png";